module.exports = __webpack_public_path__ + "528b57fdc5f2f51a20e867c5552b891b.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/uruzNaranja.png
// module id = 2163
// module chunks = 0